import React, { Component, } from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'

import PropTypes from 'prop-types'

import Firebase from 'firebase'

import _ from 'lodash'
import {FirebaseUtils, CCUIUtils, Constants, DataActionTypes, CCButton, CCInput, strings, CCActions, colors, CCActivityIndicator,CCBackLayout} from "./../../cc-imports";

// import './claim_rewards.css'

import './../../styles/css/screens/ClaimReward/claim-reward.css'

class ClaimReward extends Component {

    static propTypes = {
        ntfn : PropTypes.object

    }

    static defaultProps = {
        ntfn : {}
    }

    constructor(props) {
        super(props)
        this.state = {

        }
        this._getButtonTitle=this._getButtonTitle.bind(this);
        this._onSubmit=this._onSubmit.bind(this);
        this._isProcessed=this._isProcessed.bind(this);
    }

    componentWillMount(){

    }

    componentDidMount() {
        if(this.props.ntfn.reward && this.props.ntfn.reward.id) {
            FirebaseUtils.getIdTokenWhenAuthChanged((idToken)=>{
                this.props.actions.getReward({accessToken:idToken}, this.props.ntfn.reward.id, DataActionTypes.GET);

            })
        }
    }

    _getButtonTitle(reward){
        switch (reward.status) {
            case (Constants.rewardStatus.CREATED):
                return strings('claim');
                break;
            case Constants.rewardStatus.CLAIMED:
                return strings('update');
                break;
            case Constants.rewardStatus.PROCESSED:
                return strings('processed');
                break;
        }
    }

    _updateReward(reward){
        var { claimDetails} = reward;
        _.each(claimDetails,(claimDetail)=>{
            if(this.state[claimDetail.key]){
                _.merge(claimDetail,{value : this.state[claimDetail.key]});
            }
        });
        //console.log(reward,'hhhhhhh')

        return reward;
    }

    _validateAndSubmit(reward) {
        var { claimDetails} = reward;
        var err = undefined;
        _.each(claimDetails,(claimDetail)=> {
            var val = this.state[claimDetail.key];
            if( claimDetail.value==undefined &&  (val==undefined || val==null) ){
                err = strings("invalid_filed_instruction",{fieldName : CCUIUtils.getLocaleStr(claimDetail.name)});
            }
        });

        if(err){
            this.setState({error : err});
        }
        else {
            this.setState({error : undefined},()=>{
                this._onSubmit(reward);
            });
        }


    }

    _onSubmit(reward){
        Firebase.auth().currentUser.getIdToken(false).then((idToken)=>{
            switch (reward.status) {
                case (Constants.rewardStatus.CREATED):
                    var updatedReward = this._updateReward(reward);
                    this.props.actions.claimReward({accessToken:idToken},updatedReward,DataActionTypes.UPDATE);
                    break;
                case Constants.rewardStatus.CLAIMED:
                    var updatedReward = this._updateReward(reward);
                    this.props.actions.updateClaimReward({accessToken:idToken},updatedReward,DataActionTypes.UPDATE);
                    break;
            }
        })
    }

    _isProcessed(reward){
        return reward.status==Constants.rewardStatus.PROCESSED;
    }

    render() {
        let {ntfn} = this.props;
        const rewardId = ntfn.reward.id;
        const reward = this.props.rewards.rewards.rewards[rewardId];

        const {claimProcedure, claimDetails, processed, claimed, claimCoins} = reward ? reward : {};
        const {type, fetching} = this.props.rewards;
        return (
            <div style={{flex:1}} className="scroll">
                {
                    ( fetching && type == DataActionTypes.GET ) ?
                        <div className={"flex-container"} style={{flex:1, alignItems:'center', justifyContent:'center', height : '6vw'}}>
                            <CCActivityIndicator size={'s'}/>
                        </div>
                        :
                        <div style={{flex:1}}>
                            {
                                reward != undefined ?
                                    <div className={'flex-container'} style={{flex:1, alignItems:'center'}}>
                                        <div className={'claimRewardsParent2'}>
                                            <h3 className={"claimRewardsTitle1"}>{CCUIUtils.getLocaleStr(ntfn.title)}</h3>
                                            <h2 className={"claimRewardsText1"} >{CCUIUtils.getLocaleStr(ntfn.message)}</h2>

                                            <div style={{ height:1, width:'80%', marginLeft:20, marginRight:20, flexDirection:'row',justifyContent:'center', alignItems:'center', marginTop:10, borderBottomColor:colors.theme2.border_color2, borderBottomWidth:0.5}}/>

                                            <h4  className={"claimRewardsText2"}>{strings('reward_reference',{reference : reward.reference})}</h4>

                                            {
                                                true &&
                                                <div className={'flex-container'} style={{flex:1, alignItems:'center', justifyContent:'center'}}>
                                                    <h3 className={'claimRewardsText3'}>{strings('reward_processed')}</h3>
                                                </div>
                                            }

                                            <div style={{ height:1,width:'80%', marginLeft:80, marginRight:20, flexDirection:'row',justifyContent:'center', alignItems:'center', borderBottomColor:colors.theme2.border_color2, borderBottomWidth:0.5}}/>

                                            <h3 className={'claimRewardsText3 m'}>{strings('claim_reward_instructions_title')}</h3>
                                            {
                                                claimProcedure &&
                                                <div>
                                                    {
                                                        claimProcedure.map((procedure, index)=>{
                                                            return(<h3 key={index } className={'claimRewardsText3 s'}>{CCUIUtils.getLocaleStr(procedure)}</h3>)
                                                        })
                                                    }
                                                </div>
                                            }
                                            <div className="flex-container" style={{width:'80%', marginLeft:20, marginRight:20, flexDirection:'row',justifyContent:'center', alignItems:'center', marginTop:20, borderBottomColor:colors.theme2.border_color2, borderBottomWidth:0.5}}/>
                                            {
                                                claimDetails &&
                                                <div style={{flex:1, width:'100%', marginTop:10, marginBottom:10}}>
                                                    {
                                                        claimDetails.map((claimDetail, index)=>{
                                                            return( <CCInput className={'claimRewardsInput'} inputClassName={'claimRewardsInputLabel'} errorClassName={'claimRewardsInputLabel'} labelClassName={'claimRewardsInputLabel'} immediate={true} editable={!this._isProcessed(reward)} value={claimDetail.value} onEndEditing={(value) => {
                                                                var state = this.state;
                                                                state[claimDetail.key]=value;
                                                                this.setState(state,()=>{});
                                                            }} key={index} type={claimDetail.type.toLowerCase()} label={CCUIUtils.getLocaleStr(claimDetail.name)} required={claimDetail.required} />)
                                                        })
                                                    }
                                                </div>
                                            }
                                            {
                                                !this._isProcessed(reward) &&
                                                <div className={'flex-container'} style={{flex:1, marginBottom:20, alignItems:'center', justifyContent:'center', flexDirection:'column'}}>
                                                    {
                                                        claimCoins > 0 &&
                                                        <h3 style={{marginTop:5, marginBottom:5, color :"#ffffff", fontSize:10, textAlign:'center'}}>{strings('claim_coins_message',{claimCoins:claimCoins})}</h3>
                                                    }
                                                    <button className={'claimRewardsBtn'} loading={(type==DataActionTypes.UPDATE && fetching)} disabled={this._isProcessed(reward)} onClick={()=>{this._validateAndSubmit(reward)}}>{this._getButtonTitle(reward)}</button>
                                                    {
                                                        this.state.error &&
                                                        <div style={{flex:1, alignItems:'center', justifyContent:'center'}}>
                                                            <h1 style={{width:'80%', textAlign: 'center', color: colors.theme.txt_color4}}>{this.state.error}</h1>
                                                        </div>
                                                    }
                                                </div>

                                            }
                                        </div>
                                    </div>
                                    :
                                    <div/>
                            }
                        </div>
                }
            </div>
        )
    }
}

export default connect(state=>({
    profile : state.profile,
    profileTabNavigation:state.profileTabNavigation,
    user : state.user,
    fireBaseUser : state.fireBaseUser,
    rewards : state.rewards
}), (dispatch)=>({
    actions: bindActionCreators({...CCActions}, dispatch),
    dispatch: dispatch
}))(ClaimReward);


// WEBPACK FOOTER //
// ./src/app/screens/ClaimReward/ClaimReward.js